/* https://github.com/backstage/backstage/blob/master/plugins/catalog/src/alpha/translation.ts  */

import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

/** @alpha */
export const catalogTranslationRef = createTranslationRef({
  id: 'catalog-entity-view',
  messages: {
    entityLayout: {
      warningPanelTitle: 'Could not fetch catalog entities.',
    },
    entityHeader: {
      back: 'Back',
      systemLabel: 'System',
      domainLabel: 'Domain',
      ownerLabel: 'Owner',
      typeLabel: 'Type',
      lifecycleLabel: 'Lifecycle',
      parentGroupLabel: 'Parent Group',
      childGroupsLabel: 'Child Groups',
      viewAll: 'view all',
      refreshScheduledMessage: 'Refresh scheduled',
      refreshButtonTitle: 'Schedule entity refresh',
      qualitySeal: 'Quality Seal',
    },
    entityContextMenu: {
      copiedMessage: 'Copied!',
      moreButtonTitle: 'More',
      inspectMenuTitle: 'Inspect entity',
      copyURLMenuTitle: 'Copy entity url',
      unregisterMenuTitle: 'Unregister entity',
      editMenuTitle: 'Edit entity',
      changeLocationMenuTitle: 'Change Source Location',
    },
    overviewTopLinks: {
      viewSource: 'View Source',
      viewSourceCodeRepo: 'View Codebase',
      installInVSCode: 'Install in VS Code',
      viewTechdocs: 'View TechDocs',
      launchTemplate: 'Launch Template',
      viewLeanIX: 'View LeanIX',
    },
    sidebar: {
      ownerHeader: 'Owner',
      contactOwner: 'Contact Owner',
      generalInfo: 'General Info',
      readMore: 'Read more',
      showLess: 'show less',
      linksHeader: 'Useful Links',
      seeAll: 'See all',
      allLinks: 'All Links',
      groupContactsTitle: 'Contacts',
      groupContactsEmailText: 'Contact through email',
      tokenNotGeneratedTitle: 'Token not generated',
      tokenGenerateButtonLabel: 'Generate Token',
      tokenGeneratedTitle: 'Authentication Token',
      tokenValidText: 'Valid from {{validFrom}} until {{validTo}}',
      tokenCreatedText: 'Created by ',
      tokenDeleteLabel: 'Delete Token',
      tokenGenerateDialogTitle: 'Token successfully created',
      tokenGenerateDialogDesc:
        'Copy and save your token at a safe location. For security reasons, after you close this modal, the token will not be no longer accessible',
      tokenGeneratedCopy: 'Copy to clipboard',
      tokenGeneratedClose: 'Close',
      tokenModalDeleteAction: 'delete',
      tokenModalDeleteTitle: 'Delete current token',
      tokenModalDeleteMessage:
        'Do you really want to delete the current token?',
      tokenModalErrorCreateTitle: 'Failed to create token',
      tokenModalErrorDeleteTitle: 'Failed to delete token',
      tokenModalErrorCreateMessage:
        'There was an error while trying to generate your token.',
      tokenModalErrorDeleteMessage:
        'There was an error while trying to delete your token.',
      tokenModalErrorAction: 'report',
      cancel: 'Cancel',
      delete: 'Delete',
      close: 'Close',
      groupOwnershipTitle: 'Ownership',
      view: 'View',
      providers: 'Providers',
      allProviders: 'All Providers',
      consumers: 'Consumers',
      allConsumers: 'All Consumers',
    },
    entityContent: {
      systemEntitiesTitle: 'System Entities',
      Subcomponents: 'Subcomponents',
      apis: 'APIs',
      components: 'Components',
      resources: 'Resources',
      systems: 'Systems',
      groupMembersTitle: 'Members',
      groupMembersCount: '{{memberCount}} Members',
      relationGraphTitle: 'Relations',
      viewGraph: 'View graph',
      emptyHeading: 'No {{entityType}} available',
      emptyDesc:
        "There are currently no {{entityType}} available! They'll will appear here once you add them",
      emptyHelpLinkTitle: 'Learn how to change this',
      subComponentsEmptyLink: '/docs/default/component/xelerate/component',
      componentsEmptyLink: '/docs/default/component/xelerate/component',
      apisEmptyLink: '/docs/default/component/xelerate/api',
      resourcesEmptyLink: '/docs/default/component/xelerate/resource',
      systemsEmptyLink: '/docs/default/component/xelerate/system',
      groupMemebersEmptyLink: '/docs/default/component/xelerate/group',
    },
    apiDefinition: {
      cardTitle: 'Definition',
      openAPI: 'OpenAPI',
      raw: 'Raw',
    },
    forbidenAccess: {
      title: 'Access Denied',
      ownerExistDesc:
        'This asset is in a protected branch, and only the owner can merge you in. Please reach out to the owner.',
      ownerNoExistDesc: `You are not authorised to view this page and currently there's no owner to this project so you'll need to reach out to us.`,
      contactOwner: 'Contact owner',
      contactUs: 'Contact us',
      ownerBottomAlert:
        'The XELERATE team is not able to change the access permissions. This is handled decentrally by all the respective teams that are in charge.',
    },
    entityError: {
      entityProcessingErrorsDescription: 'The error below originates from',
      entityRelationWarningTitle: 'Relation to other entities not found.',
      entityRelationWarningDescription:
        "This entity has relations to other entities, which can't be found in the catalog. Entities not found are: ",
      entityRelationWarningNote: {
        users:
          'Please ensure these entities are registered in the catalog. Note: Users are automatically registered upon first login.',
        groups: 'Please ensure these entities are registered in the catalog.',
      },
      entityRelationWarningLinks: {
        users:
          'https://developer.cariad.digital/docs/default/component/xelerate/user/',
        groups:
          'https://developer.cariad.digital/docs/default/component/xelerate/group/',
        entites:
          'https://developer.cariad.digital/docs/default/component/xelerate/entities/#relationships-between-components',
      },
      missingDocumentationTitle: 'Documentation Not Found',
      missingDocumentationDescription:
        'This entity is configured to display docs, but no files were found in the data base. Please upload your documentation or remove the docs annotation to resolve this issue.',
      missingDocumentationLinks: {
        techdocs: '/docs/default/component/xelerate/guide-publishing/',
      },
    },
    support: {
      supportButtonLabel: 'Get Support',
      listTitle: 'Get Support',
      listDescription: 'Reach out to the owners',
    },
    userProfileCard: {
      userNotFound: 'User not found',
      editIconButtonTitle: 'Edit Metadata',
      listItemTitle: {
        email: 'Email',
        memberOf: 'Member of',
      },
      moreGroupButtonTitle: '...More ({{number}})',
      allGroupDialog: {
        title: "All {{name}}'s groups:",
        closeButtonTitle: 'Close',
      },
    },
    qualitySealStatusModal: {
      headerTitle: 'Quality Seal',
      headerDesc:
        'The Quality Seal ensures entities are actively maintained and validated by their owners.',
    },
    qualitySealActionMenu: {
      headerTitle: 'Change to:',
    },
  },
});
